import PayoutDetailsInfo from './PayoutDetailsInfo';

export default PayoutDetailsInfo;
